export default __webpack_public_path__ + "static/media/arrow_right_white.f1b3acdf.svg";